import React from 'react';
import { motion } from 'framer-motion';

export default function AdminButton({ title, description, onClick, icon, isHighlighted = false, unreadCount = 0, highlightColor = 'red' }) {
  console.log(`🔘 AdminButton "${title}" - isHighlighted: ${isHighlighted}, unreadCount: ${unreadCount}`);

  const highlightButtonClass = highlightColor === 'red'
    ? 'bg-red-600 border-red-600 text-white hover:bg-red-700'
    : 'bg-blue-600 border-blue-600 text-white hover:bg-blue-700';
  const highlightIconClass = 'bg-white/10 text-white';

  return (
    <motion.button
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.4 }}
      onClick={onClick}
      className={`group text-left p-6 rounded-2xl border shadow-sm hover:shadow-lg transition-all duration-300 relative ${
        isHighlighted 
          ? highlightButtonClass
          : 'border-slate-200 bg-white hover:border-slate-300 text-slate-900'
      }`}
    >
      {/* Unread count badge */}
      {unreadCount > 0 && (
        <div className="absolute -top-2 -right-2 bg-white text-red-700 text-xs font-bold rounded-full h-6 w-6 flex items-center justify-center shadow-lg border border-red-200">
          {unreadCount > 99 ? '99+' : unreadCount}
        </div>
      )}
      
      <div className={`text-4xl mb-4 rounded-2xl p-4 grid place-items-center ${isHighlighted ? highlightIconClass : 'bg-slate-100 text-slate-600'}`}>
        {icon}
      </div>
      <h3 className={`text-base font-semibold transition-colors ${isHighlighted ? 'text-white' : 'text-slate-900 group-hover:text-slate-900'}`}>
        {title}
      </h3>
    </motion.button>
  );
}
